export const contact = {
  title: 'CONTACT US',
  
  // Contact Information
  info: {
    email: {
      label: 'EMAIL',
      primary: 'concierge@lucendoelite.com',
      secondary: 'private@lucendoelite.com',
    },
    address: {
      label: 'ADDRESS',
      line1: 'Paradise AVM, Adnan Kahveci Mah.',
      line2: 'Yavuz Sultan Selim Blv. No:16 D:39,',
      line3: '34528 Beylikdüzü/İstanbul/Türkiye',
    },
  },
};
